<template>
  <div class="list-page-header">
    <h3 class="title">{{ this.$t("class.list_page_title") }}</h3>
    <md-button
      v-if="this.$can(Class.actions.add, Class.subject)"
      class="md-success ml-6"
      @click.native.prevent="go2AddPage"
      >{{ $t("common.add_new") }}</md-button
    >
  </div>
</template>

<script>
import { class_router_names } from "@/routes/routes";
import { Class } from "@/constants/Permissions";

export default {
  name: "list-page-header",
  data() {
    return {
      Class
    };
  },
  methods: {
    go2AddPage() {
      this.$router.push({ name: class_router_names.addPage });
    }
  }
};
</script>
